import { SalesforceAPI } from 'module/api/integrations/salesforce';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { faFileExport } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useParams } from '@rocketlane/rocket-router';
import { Button } from '@rocketlane/ui';
import {
  useSalesForceErrorLogsQuery,
  useSalesforceConfigByIdQuery,
} from 'queries/salesforce';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { SalesforceTabs } from 'components/molecules/integrations/salesforce/tabs';
import { SalesforceTabsType } from 'components/molecules/integrations/salesforce/tabs';
import { ErrorLogTable } from 'components/organisms/integrations/salesforce/error-logs';
import { SalesforceLayout } from './salesforce-layout';

const ErrorPageContainer = styled.div`
  padding: 16px;
  height: 90vh;
`;

const ErrorLogsPage: FC = () => {
  const { integrationId } = useParams<{ integrationId: string }>();

  const {
    data: errorLogs = [],
    isLoading,
    error,
  } = useSalesForceErrorLogsQuery(integrationId || '', {
    enabled: !!integrationId && integrationId !== 'new',
  });

  const { data } = useSalesforceConfigByIdQuery(Number(integrationId), {
    enabled: integrationId !== 'new',
  });

  if (error) {
    return <div>Error loading error logs</div>;
  }

  const onExport = async () => {
    if (integrationId && integrationId !== 'new') {
      SalesforceAPI.getSalesForceErrorLogsInCSV(integrationId).then(
        (downloadUrl) => {
          window.open(downloadUrl, '_blank');
        },
      );
    }
  };

  return (
    <SalesforceLayout
      tabs={
        <SalesforceTabs
          activeKey={SalesforceTabsType.ErrorLogs}
          integrationId={integrationId}
          integrationStatus={data?.integrationStatus}
        />
      }
      content={
        isLoading ? (
          <PageLoading />
        ) : (
          <ErrorPageContainer>
            <div className="flex justify-end">
              <Button
                variant="primary"
                onClick={onExport}
                className="mb-4 align-right"
                rightIcon={<FontAwesomeIcon icon={faFileExport} />}
              >
                <FormattedMessage id="settings.integrations.sf.error_logs.export" />
              </Button>
            </div>

            <ErrorLogTable records={errorLogs} />
          </ErrorPageContainer>
        )
      }
      actions={{}}
    />
  );
};

export { ErrorLogsPage };
